module.exports = __webpack_public_path__ + "static/media/plusIcon.462db492.svg";